import { UserProfileDto } from "@/types";
import {
  createGlobalState,
  useLocalStorage,
  useSessionStorage,
} from "@vueuse/core";

const useState = createGlobalState(() =>
  useLocalStorage("store", {
    authentication: {
      token: "",
      username: "",
    },
  })
);

const useSessionState = createGlobalState(() =>
  useSessionStorage<{
    profile: UserProfileDto;
    loadingCount: number;
    loadingMessage: string;
  }>("sessionstore", {
    profile: {
      employeeId: "",
      isAdmin: false,
      isOnTheJobAdmin: false,
      isPdpaAccepted: true,
      isLineLinked: false,
      lineRegisterLink: "",
      noApproverLevel: 10,
    },
    loadingCount: 0,
    loadingMessage: "",
  })
);

const state = useState();

const commitLogout = () => {
  state.value.authentication.token = "";
  state.value.authentication.username = "";
};

export { useState, commitLogout, useSessionState };

// import { AppState, UserProfileDto } from "@/types";
// import { createStore } from "vuex";
// import VuexPersistence from "vuex-persist";

// const vuexLocal = new VuexPersistence<AppState>({
//   storage: window.localStorage,
//   reducer: (state) => ({
//     authentication: state.authentication,
//   }),
// });

// const state: AppState = {
//   authentication: {
//     token: "",
//     username: "",
//   },
//   profile: {
//     employeeId: "",
//     isAdmin: false,
//     isOnTheJobAdmin: false,
//     isPdpaAccepted: true,
//   },
//   loadingCount: 0,
//   loadingMessage: "",
//   roles: [],
// };

// export default createStore<AppState>({
//   state: state,
//   mutations: {
//     login(state, { token, username }) {
//       state.authentication.token = token;
//       state.authentication.username = username;
//     },
//     logout(state) {
//       state.authentication.token = "";
//       state.authentication.username = "";
//     },
//     setRoles(state, roles) {
//       state.roles = Array.isArray(roles) ? roles : [];
//     },
//     setLoading(state, isLoading) {
//       state.loadingCount += isLoading ? 1 : -1;
//     },
//     setLoadingMessage(state, message) {
//       state.loadingMessage = message;
//     },
//     setProfile(state, profile: UserProfileDto) {
//       state.profile = profile;
//     },
//   },
//   modules: {},
//   plugins: [vuexLocal.plugin],
// });
